import { useEffect } from "react";
import { useOverlayOrchestrator } from "../../createOverlayOrchestratorContext";
import { useOverlayStepsOrchestrator } from "../../useOverlayStepsOrchestrator";
import { BRAND_CONFIGURATION } from "../../../../../configs/brands";
const KEY = "adjust-banner";
const { adjust } = BRAND_CONFIGURATION.appBanner ?? {};
export const useInitAdjustBanner = () => {
    const { dispatch } = useOverlayOrchestrator();
    const canProceed = useOverlayStepsOrchestrator(KEY);
    useEffect(() => {
        if (!adjust) {
            dispatch({ type: "DISABLE", payload: KEY });
            return;
        }
        if (canProceed) {
            dispatch({ type: "INIT", payload: KEY });
        }
    }, [canProceed, dispatch]);
};
